var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-row", [_c("h1", [_vm._v("Clientes Varejo")])]),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-button",
                {
                  staticClass: "mr-3",
                  attrs: { variant: "primary", size: "sm", title: "Voltar" },
                  on: { click: _vm.voltar }
                },
                [
                  _c("i", { staticClass: "fas fa-arrow-left" }),
                  _vm._v(" Voltar")
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-2 mb-3" },
        [
          _c(
            "b-card",
            { staticClass: "col-md-11" },
            [
              _c(
                "b-row",
                { staticClass: "mb-2" },
                [
                  _c(
                    "b-col",
                    { staticClass: "col-md-6" },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "buscar",
                          size: "sm",
                          placeholder: "Buscar",
                          type: "search"
                        },
                        model: {
                          value: _vm.filter,
                          callback: function($$v) {
                            _vm.filter = $$v
                          },
                          expression: "filter"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-table", {
                    attrs: {
                      items: _vm.clientes,
                      busy: _vm.isLoading,
                      fields: _vm.header,
                      "empty-text": "Nenhum cliente encontrado...",
                      stacked: "xl",
                      "sort-by": _vm.sortBy,
                      "sort-desc": _vm.sortDesc,
                      "sort-direction": _vm.sortDirection,
                      "current-page": _vm.currentPage,
                      "per-page": _vm.perPage,
                      filter: _vm.filter,
                      "filter-included-fields": _vm.filterOn,
                      "show-empty": "",
                      small: "",
                      striped: "",
                      hover: ""
                    },
                    on: {
                      "update:sortBy": function($event) {
                        _vm.sortBy = $event
                      },
                      "update:sort-by": function($event) {
                        _vm.sortBy = $event
                      },
                      "update:sortDesc": function($event) {
                        _vm.sortDesc = $event
                      },
                      "update:sort-desc": function($event) {
                        _vm.sortDesc = $event
                      },
                      filtered: _vm.onFiltered
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "table-busy",
                        fn: function() {
                          return [
                            _c(
                              "div",
                              { staticClass: "text-center text-danger my-2" },
                              [
                                _c("b-spinner", {
                                  staticClass: "align-middle"
                                }),
                                _vm._v(" "),
                                _c("strong", [_vm._v("Carregando ...")])
                              ],
                              1
                            )
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "cell(editar)",
                        fn: function(row) {
                          return [
                            _c(
                              "b-button",
                              {
                                attrs: {
                                  size: "sm",
                                  title: "Boletos",
                                  variant: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.showBoletos(row.item)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fa fa-barcode" })]
                            ),
                            _vm._v(" "),
                            _vm.perfil == "adm" ||
                            _vm.perfil == "gerente_varejo"
                              ? _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      size: "sm",
                                      title:
                                        "Alterar Grupo de Desconto e Prazo",
                                      variant: "success"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.editar(row.item)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-hand-holding-usd"
                                    })
                                  ]
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-2 mb-1" },
                [
                  _c(
                    "b-col",
                    [
                      _c("b-pagination", {
                        staticClass: "my-0",
                        attrs: {
                          "total-rows": _vm.totalRows,
                          "per-page": _vm.perPage,
                          align: "fill",
                          size: "sm"
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("b-col", { staticClass: "text-right" }, [
                    _vm._v(
                      "\n          Total de Clientes: " +
                        _vm._s(_vm.clientes.length) +
                        "\n        "
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { size: "lg" },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function() {
                return [
                  _c("h6", { staticClass: "text-primary" }, [
                    _c("b", [_vm._v(" " + _vm._s(_vm.selecionado.nome) + " ")])
                  ])
                ]
              },
              proxy: true
            },
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _vm.perfil === "adm" || _vm.perfil === "gerente_varejo"
                    ? _c(
                        "b-button",
                        {
                          attrs: { variant: "primary", size: "sm" },
                          on: { click: _vm.salvar }
                        },
                        [_vm._v("\n        Salvar")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "danger", size: "sm" },
                      on: {
                        click: function($event) {
                          _vm.modalDesconto = false
                        }
                      }
                    },
                    [_vm._v("Fechar")]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.modalDesconto,
            callback: function($$v) {
              _vm.modalDesconto = $$v
            },
            expression: "modalDesconto"
          }
        },
        [
          _c(
            "b-card",
            [
              _c(
                "b-row",
                [
                  _c("b-col", { staticClass: "col-md-4" }, [
                    _vm._v(" Código: ")
                  ]),
                  _vm._v(" "),
                  _c("b-col", [
                    _c("b", { staticClass: "text-primary" }, [
                      _vm._v(" " + _vm._s(_vm.selecionado.codigo))
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { staticClass: "col-md-4" }, [
                    _vm._v(" Data de Cadastro: ")
                  ]),
                  _vm._v(" "),
                  _c("b-col", [
                    _c("b", { staticClass: "text-primary" }, [
                      _vm._v(_vm._s(_vm.selecionado.criacao) + " ")
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { staticClass: "col-md-4" }, [
                    _vm._v(" Última Alteração: ")
                  ]),
                  _vm._v(" "),
                  _c("b-col", [
                    _c("b", { staticClass: "text-primary" }, [
                      _vm._v(_vm._s(_vm.selecionado.editado))
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-3", attrs: { "align-v": "end" } },
                [
                  _c("b-col", { staticClass: "col-md-4" }, [
                    _c("label", { attrs: { for: "grupoDesc" } }, [
                      _vm._v("Prazo de Pagamento:")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "col-md-4" },
                    [
                      _vm.selecionado
                        ? _c("b-form-select", {
                            attrs: {
                              size: "sm",
                              disabled:
                                _vm.perfil !== "adm" &&
                                _vm.perfil !== "gerente_varejo",
                              options: _vm.optionsPrazo
                            },
                            model: {
                              value: _vm.selecionado.prazo_pagamento_id,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.selecionado,
                                  "prazo_pagamento_id",
                                  $$v
                                )
                              },
                              expression: "selecionado.prazo_pagamento_id"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-3", attrs: { "align-v": "end" } },
                [
                  _c("b-col", { staticClass: "col-md-4" }, [
                    _c("label", { attrs: { for: "grupoDesc" } }, [
                      _vm._v("Grupo de Desconto:")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _vm.selecionado
                        ? _c("b-form-select", {
                            attrs: {
                              size: "sm",
                              disabled:
                                _vm.perfil !== "adm" &&
                                _vm.perfil !== "gerente_varejo",
                              id: "grupoDesc",
                              options: _vm.options
                            },
                            on: { change: _vm.buscaGrupo },
                            model: {
                              value: _vm.selecionado.grupo_desconto_varejo,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.selecionado,
                                  "grupo_desconto_varejo",
                                  $$v
                                )
                              },
                              expression: "selecionado.grupo_desconto_varejo"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      !_vm.mostrar
                        ? _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName: "v-b-toggle.collapse-1",
                                  modifiers: { "collapse-1": true }
                                }
                              ],
                              attrs: { variant: "secondary", size: "sm" },
                              on: { click: _vm.buscaGrupo }
                            },
                            [
                              _vm.loadGrupo
                                ? _c("b-spinner", { attrs: { small: "" } })
                                : _vm._e(),
                              _vm._v("\n            Mostrar\n          ")
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.mostrar
                        ? _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName: "v-b-toggle.collapse-1",
                                  modifiers: { "collapse-1": true }
                                }
                              ],
                              attrs: { variant: "secondary", size: "sm" },
                              on: {
                                click: function($event) {
                                  _vm.mostrar = false
                                }
                              }
                            },
                            [
                              _vm.loadGrupo
                                ? _c("b-spinner", { attrs: { small: "" } })
                                : _vm._e(),
                              _vm._v("\n            Ocultar\n          ")
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "md-12" },
                [
                  _c(
                    "b-col",
                    { staticClass: "col-md-12" },
                    [
                      _c(
                        "b-collapse",
                        {
                          staticClass: "mt-2 md-10",
                          attrs: { id: "collapse-1" }
                        },
                        [
                          _c(
                            "b-container",
                            {
                              staticClass: "mt-2 md-12",
                              attrs: { fluid: "xl" }
                            },
                            [
                              _c(
                                "b-card",
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _c("b-table", {
                                        attrs: {
                                          items: _vm.grupo,
                                          fields: _vm.headerGrupo,
                                          striped: "",
                                          small: ""
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { size: "xl" },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function() {
                return [
                  _c("h6", { staticClass: "text-primary" }, [
                    _c("b", [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.clienteSelecionado.codigo +
                              " - " +
                              _vm.clienteSelecionado.nome
                          ) +
                          "\n        "
                      )
                    ])
                  ])
                ]
              },
              proxy: true
            },
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { size: "sm", variant: "primary" },
                      on: {
                        click: function($event) {
                          _vm.modalBoletos = false
                        }
                      }
                    },
                    [_vm._v("Fechar")]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.modalBoletos,
            callback: function($$v) {
              _vm.modalBoletos = $$v
            },
            expression: "modalBoletos"
          }
        },
        [
          _c(
            "b-card",
            [
              _c(
                "b-row",
                { attrs: { "align-v": "end" } },
                [
                  _c(
                    "b-col",
                    { staticClass: "md-4" },
                    [
                      _c("label", { attrs: { for: "status" } }, [
                        _vm._v("Status")
                      ]),
                      _vm._v(" "),
                      _c("b-form-select", {
                        attrs: {
                          id: "status",
                          size: "sm",
                          options: _vm.listStatus
                        },
                        model: {
                          value: _vm.statusBoleto,
                          callback: function($$v) {
                            _vm.statusBoleto = $$v
                          },
                          expression: "statusBoleto"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "md-3" },
                    [
                      _c("label", { attrs: { for: "dateD" } }, [
                        _vm._v("Vencimento De")
                      ]),
                      _vm._v(" "),
                      _c("b-form-datepicker", {
                        attrs: {
                          id: "dateD",
                          placeholder: "Nenhuma Data",
                          "calendar-width": "200",
                          "label-no-date-selected": "",
                          "label-next-month": "Próximo Mês",
                          "label-next-year": "Próximo Ano",
                          "label-prev-month": "Mês Anterior",
                          "label-prev-year": "Ano Anterior",
                          "label-current-month": "Mês Atual",
                          "label-help": "",
                          "hide-header": "",
                          "reset-button": "",
                          "reset-button-variant": "danger",
                          "label-reset-button": "Limpar",
                          size: "sm",
                          "date-format-options": {
                            year: "numeric",
                            month: "numeric",
                            day: "numeric"
                          },
                          locale: "pt-BR"
                        },
                        model: {
                          value: _vm.dataDe,
                          callback: function($$v) {
                            _vm.dataDe = $$v
                          },
                          expression: "dataDe"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "md-3" },
                    [
                      _c("label", { attrs: { for: "dateA" } }, [_vm._v("Até")]),
                      _vm._v(" "),
                      _c("b-form-datepicker", {
                        attrs: {
                          id: "dateA",
                          placeholder: "Nenhuma Data",
                          "calendar-width": "200",
                          "label-no-date-selected": "",
                          "label-next-month": "Próximo Mês",
                          "label-next-year": "Próximo Ano",
                          "label-prev-month": "Mês Anterior",
                          "label-prev-year": "Ano Anterior",
                          "label-current-month": "Mês Atual",
                          "label-help": "",
                          "hide-header": "",
                          "reset-button": "",
                          "reset-button-variant": "danger",
                          "label-reset-button": "Limpar",
                          size: "sm",
                          "date-format-options": {
                            year: "numeric",
                            month: "numeric",
                            day: "numeric"
                          },
                          locale: "pt-BR"
                        },
                        model: {
                          value: _vm.dataAte,
                          callback: function($$v) {
                            _vm.dataAte = $$v
                          },
                          expression: "dataAte"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "md-2" },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            disabled: _vm.loadBoleto,
                            size: "sm",
                            variant: "primary"
                          },
                          on: { click: _vm.loadBoletos }
                        },
                        [
                          _vm.loadBoleto
                            ? _c("b-spinner", { attrs: { small: "" } })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("i", { staticClass: "fas fa-search" }),
                          _vm._v("\n            Buscar\n          ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _vm.boletos.length > 0
                    ? _c("b-table", {
                        staticClass: "mt-2",
                        attrs: {
                          items: _vm.boletos,
                          fields: _vm.headerBoleto,
                          striped: "",
                          small: ""
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "cell(boleto)",
                              fn: function(row) {
                                return [
                                  !row.item.BAIXA
                                    ? _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            size: "sm",
                                            variant: "primary"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.gerarBoleto(row.item)
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-file-pdf"
                                          })
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2336538454
                        )
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11dd4678", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11dd4678","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/varejo/distribuidores/index.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-11dd4678","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/varejo/distribuidores/index.vue
// module chunks = 2